export default function noop() {
  return undefined
}



// WEBPACK FOOTER //
// ./src/utils/noop.ts